import React, { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import POS from './POS';
import BakeryPOS from './Bakery/BakeryPOS';
import { fetchPosOrderTypeSettings } from '../../utils/posOrderTypeSettings';

export default function POSProfileRouter() {
  const [profile, setProfile] = useState(null);
  useEffect(() => {
    fetchPosOrderTypeSettings()
      .then((settings) => setProfile(settings.businessProfile))
      .catch(() => setProfile('restaurant'));
  }, []);
  if (!profile) return <Box sx={{ minHeight: '70vh', display: 'grid', placeItems: 'center' }}><CircularProgress /></Box>;
  return profile === 'bakery' ? <BakeryPOS /> : <POS />;
}
